<template>
  <div
    style="width: 100%; height: 100%"
    ref="autoLayoutContainer"
    @dragover="dragoverEv"
    @dragleave.prevent="isDragover = false"
    @drop="handleAutoLayoutDragover($event)"
  >
    <!--    目测去掉 @click 事件没有影响，如果加上会造成拖拽组件，鼠标在通栏上放开，此时toolbar的设置项由之前组件变为通栏-->
    <div  class="layout-row__container">
      <!--布局-->
      <ul v-model="rows"  style="width:100%;height:100%" :forceFallback="true">
        <!--通栏里的行-->
        <template v-for="(col, index) in rows">
          <li
            :style="getRowStyle(col, 'row', index, layout.layout.rows, layout.options)"
            :class="[
               'layout-col layout-col-fullPage',
                (layout.options.childSizeAuto || col.options.childSizeAuto) && col.rectIds && col.rectIds.length > 0
                ? 'no-size-limit'
                : '',
                col.options.showRowColLayout ? col.options.rowColDirection !== 'horizon' ?'row-col-layout vertical-layout' : 'row-col-layout horizon-layout' : ''
            ]"
            :key="col.id"
          >
            <layout-tree
              :baseComponent="baseComponent"
              :col="col"
              :layoutIndex="layoutIndex + '_' + index"
              :curIndex="index"
              :parentLayout="layout.layout"
              :zoom="zoom"
              :id="myid.container_id"
              :rect_id="myid.rect_id"
              :myid="myid"
              :options="layout.options"
              :isActive = "active"
              :isAccordionLayout="isAccordionLayout"
              :openIndex="openIndex"
            ></layout-tree>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import layoutCell from "./cell"
import VueDragResizable from "components/publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import { hasProperty, _throttle, getAttrById, deepChangeUid, getAllElementsInColsInLayoutComponent, smartMathMax } from "utils"
import layoutTree from "./layoutTree"
import {
  primaryBigScreenGenerator as primarybigScreenGenerator,
  primaryBigScreenPageLayoutGenerator as primarybigScreenPageLayoutGenerator
} from "../../../store/modules/bigScreen/state"
import {
  primaryStageGenerator as primarystageGenerator,
  primaryStagePageLayoutGenerator as primarystagePageLayoutGenerator
} from "../../../store/modules/stage/state"
import {
  primaryAppStageGenerator as primaryappStageGenerator,
  primaryappStagePageLayoutGenerator as primaryappStagePageLayoutGenerator
} from "../../../store/modules/appStage/state"
import cxTabsState from "store/modules/menu/menuComponent/cxTabsState"

const mockData = {
  primarybigScreenGenerator,
  primaryappStageGenerator,
  primarystageGenerator,
  primarybigScreenPageLayoutGenerator,
  primarystagePageLayoutGenerator,
  primaryappStagePageLayoutGenerator
}

export default {
  mixins: [],
  name: "cxPageLayoutComponent",
  components: {
    draggable,
    layoutCell,
    VueDragResizable,
    layoutTree
  },
  data() {
    return {
      textOptions: {
        type: Array,
        default: []
      },
      activeTabId: "",
      appId: null,
      pageId: null,
      restDataUrl: null,
      typeVal: null,
      websiteId: null,
      wfwfid: null,
      colsIdFromActiveRect: [],
      cacheDataTypes: [],
      testData: [1, 2, 4],
      _self: this,
      resizeStartSite: null,
      paddingDragging: false,
      isDragover: false,
      layoutIndex: 0,
      baseComponent: [
        "cxText",
        "cxLabel",
        "imageComponent",
        "cxHomeLine",
        "cxButton",
        "cxEditor",
        "cxShape",
        "cxRadio",
        "cxVideo",
        "cxAudio",
        "cxDigitRoll",
        "cxIcon",
        "cxVerticalLine",
        "cxNoteEditor",
        "cxBreadCrumbs",
        "cxCalendar",
        "cxTabs",
        "cxSelect",
        "cxWeather",
        "cxDate",
        "cxReturn",
        "cxBorder",
        "cxAnimate",
        // "cxIframe",
        "cxCode",
        "cxAutoLayout",
        "cxInput",
        "cxAnchorComponent"
      ],
    }
  },
  props: {
    options: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid:{
      type:Object
    },
    active:{
      type:Boolean
    }
  },
  watch: {
    options: {
      deep: true,
      handler(o, n) {
        this.$forceUpdate()
      }
    }
  },
  computed: {
    isAccordionLayout() {
      return this.layout?.options?.isAccordionLayout || false
    },
    openIndex: {
      get() {
        return this.layout?.options?.hasOwnProperty("openIndex") ? this.layout?.options?.openIndex : -1
      },
      set(val) {
        this.$changeOptionsEV(val, "openIndex", false, null, {
          container_id: this.myid.container_id, 
          rect_id: this.myid.rect_id,
          pageLayoutId: this.layoutIndex
        })
      }
    },
    defaultOpenIndex() {
      return this.layout?.options?.hasOwnProperty("defaultOpenIndex") ? this.layout?.options?.defaultOpenIndex : 0
    },
    ids() {
      return this.$store.state.states.activeID
    },
    id(){
      return this.myid.container_id
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    layout:{
      get(){
        return this.options.layout
      }
    },
    rows:{
      get(){
        return this.layout?.layout.rows
      }
    },
    layoutCols: {
      get() {
        if (this.request_prefix === "appStage" && this.layout.options?.isShowTabs) return this.newLayout()
        return this.layout
      },
      set(val) {
        this.$emit("update:layout", val)
      }
    },
    getRowStyle() {
      // 通栏的样式
      return function (col, cellType, index, colLength, layout) {
        let borderW = ""
        if (Array.isArray(col.options.borderWidth)) {
          col.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${col.options.borderWidth}px`
        }
        let zIndex = 1
        if (cellType === "row") {
          // 行之间设置层级
          zIndex = colLength.length - index
        }
        let options = this.layout.options
        let positionStyle = {}
        let bgStyle = this.bgStyle(col.options)
        let boxShadowStyle = this.getBoxShadowStyle(col.options)
        // 设置通栏的宽度
        let width,margin
        if (col.options.positionType && col.options.positionType !== "relative") {
          // 自定义宽度  包括之前的固定定位后的宽度
          width = "100%"
          margin = null
        } else if (options.isFullPage || this.request_prefix === "appStage") {
          width = "100%"
          margin = "0 auto"
        } else {
          margin = `0  ${options.padding[1]}px 0 ${options.padding[3]}px`
          width = `calc(100% - ${options.padding[1]}px - ${options.padding[3]}px)`
        }
        let showBorder =
          (col.layout?.rows && col.layout.rows.length > 0) || (col.layout?.cols && col.layout.cols.length > 0)
        return {
          ...positionStyle,
          ...bgStyle,
          ...this.publicStyle(col.options),
          boxShadow: boxShadowStyle,
          width: width,
          height: "100%",
          opacity: col.options.opacity / 100,
          // margin: enableBayWindow ? null : "0 auto",
          margin:  margin,
          zIndex: zIndex,
          "border-style": col.options.borderStyle,
          "border-color": this.$parseColor(col.options.borderColor, {
            isThemeColor: col.options.borderIsThemeColor
          }),
          "border-width": showBorder ? borderW : 0,
          "border-radius": `${col.options.borderRadius[0]}px ${col.options.borderRadius[1]}px ${col.options.borderRadius[2]}px ${col.options.borderRadius[3]}px`,
          "--custom-margin": options.marginBottom
            ? options.marginBottom + "px"
            : col.options?.marginBottom
              ? col.options?.marginBottom + "px"
              : "",
        }
      }
    },
    publicStyle() {
      return function (options) {
        let style = {}
        const { showBackgroundFilter, backgroundFilter } = options
        if (showBackgroundFilter) {
          style.backdropFilter = `blur(${backgroundFilter}px)`
        }
        return style
      }
    },
    bgStyle() {
      return function (options) {
        if (!options) {
          return {}
        }
        let layoutBg = options.bg
        let containerBg = {
          backgroundImage: ""
        }
        if (!layoutBg || !Array.isArray(layoutBg)) {
          return {}
        }
        layoutBg.forEach(bg => {
          switch (bg.type) {
            case "img":
              let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
              break
            case "color":
              containerBg.backgroundColor = this.$parseColor(bg)
              break
            case "linearGradient":
              let tmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  tmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                containerBg.backgroundImage += dot + this.$parseColor(bg)
                containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
              }
              break
            case "radialGradient":
              let radialTmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  radialTmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                containerBg.backgroundImage +=
                  dot + this.$parseColor(bg)
                containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
                containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
                containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
              }
              break
            default:
          }
        })
        return containerBg
      }
    },
    colBgStyle() {
      return function (col) {
        let options = col.options
        if (!options) {
          return {}
        }
        let containerBg = {
          backgroundImage: ""
        }
        if (!options.bg || !Array.isArray(options.bg)) {
          return {}
        }
        options.bg.forEach(bg => {
          switch (bg.type) {
            case "img":
              let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundSize = bg.clipSize
              containerBg.backgroundPosition = bg.alignType
              containerBg.backgroundRepeat = bg.repeatType
              break
            case "color":
              containerBg.backgroundColor = this.$parseColor(bg)
              break
            case "linearGradient":
              let tmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  tmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                containerBg.backgroundImage += dot + this.$parseColor(bg)
              }
              break
            case "radialGradient":
              let radialTmp = []
              if (bg.data.stops.length > 0) {
                bg.data.stops.forEach(item => {
                  radialTmp.push(item[0] + " " + item[1] * 100 + "%")
                })
                let dot = containerBg.backgroundImage.length > 0 ? "," : ""
                containerBg.backgroundImage +=
                  dot + this.$parseColor(bg)
              }
              break
            default:
          }
        })
        return containerBg
      }
    },
    getColStyle() {
      return function (col) {
        let padding = ""
        col.options.padding.forEach(item => {
          padding += item + "px "
        })
        let bgStyle = this.colBgStyle(col)
        return {
          ...bgStyle,
          width: col.options.width,
          height: col.options.height + "px",
          padding: padding,
          opacity: col.options.opacity / 100
        }
      }
    },
    vdrStyle() {
      const { inDocument, isRefHome } = this.layout.options
      // 详情页和列表页，以及平级页面才有遮罩，首页没有
      let pageType = this.$store.state[this.request_prefix].type
      let isSubPage = false
      if (pageType === "listPage" || pageType === "detailPage" || pageType === "equalPage") {
        isSubPage = true
      }
      return {
        position: "absolute",
        left: 0,
        bottom: 0,
        zIndex: ["header", "footer"].includes(inDocument) && isRefHome && isSubPage ? 9999999 : 0,
        width: "100%",
        height: "100%"
      }
    }
  },
  methods: {
    primaryLayout(){
      let layout = new mockData["primary" + this.request_prefix + "PageLayoutGenerator"](this.options.type)
      this.$changeOptionsEV(layout, "layout", false, null, {
        container_id:this.myid.container_id,
        rect_id: this.myid.rect_id
      }, true)
      if (layout.options?.isShowTabs) {
        let param = {
          active: false,
          draggable: true,
          hoverZIndex: 1,
          parentLim: true,
          resizable: true,
          shape: "cxTabs",
          options: JSON.parse(JSON.stringify(cxTabsState.children[0].attribute.options))
        }
        param.options.isPageLayoutTabs = true
        param.options.isNoSyncData = true
        let colRectIds = layout.layout.rows[0].layout.rows[0].rectIds
        let isShowVerticalTabs = layout.options?.isShowVerticalTabs
        let rowRectIds = null
        if (isShowVerticalTabs) {
          param.options.width = 100
          param.options.height = 200
          param.options.isPageLayoutVerticalTabs = true
          rowRectIds = layout.layout.rows[0].layout.rows[0].layout.cols[0].rectIds
        } else {
          param.options.width = 300
          param.options.height = 44
        }
        this.addNewRect({
          rectAttr: param,
          cellRect: isShowVerticalTabs ? rowRectIds : colRectIds,
          index: 0,
          type: "new",
          isClone: false,
        })
      }
    },
    // 新加入rect
    async addNewRect(param) {
      let rectAttr = JSON.parse(JSON.stringify(param.rectAttr))
      rectAttr.i = param.gridLayoutId
      deepChangeUid(rectAttr)
      // 单元格里不能放布局通栏
      if (param.type === "new") {
        // if (
        //   // this.baseComponent.indexOf(rectAttr.shape) > -1 ||
        //   this.waterFlowBaseComponent.indexOf(rectAttr.shape) > -1 ||
        //   // 特殊情况，自由布局组件，带“ListPageSearchComponentPlugin”插件的组件，作为基础组件处理
        //   (rectAttr.options.pluginName && rectAttr.options.pluginName.indexOf("ListPageSearchComponentPlugin") > -1)
        // ) {
          // 基础元素，支持在col内自由拖拽
          rectAttr.options.top = 0
          rectAttr.options.left = 0
          rectAttr.options.zIndex = 2
          rectAttr.options.parentRectId = this.ids.rect_id

          // 拖入横向标签布局时不重置布局的高度
          // if (!(rectAttr.shape === "cxTabs" && rectAttr.options.isPageLayoutTabs)) {
          //   this.changeCellSize(param.parentIndex, undefined, rectAttr.options.height)
          // }
        // } else {
          // if(rectAttr.shape === "emptyLayoutComponent" || rectAttr.shape === "layoutComponent"){
          // this.changeCellSize(param.parentIndex, undefined, rectAttr.options.height)
          // }else{
          //   this.changeCellSize(param.parentIndex,rectAttr.options.width,rectAttr.options.height)
          // }
          // 一个col里面只能放一个组件（非基础元素）
          // rectAttr.options.top = 0
          // rectAttr.options.left = 0
          // rectAttr.options.width = 100
          // rectAttr.options.widthType = "%"
          // rectAttr.options.zIndex = 1
          // rectAttr.options.draggable = false
          // rectAttr.options.resizable = false
          // }else{
          //   console.log("一个col里面只能放一个组件")
          //   return
          // }
        // }
      }
      const containerOpt = this.getAttrById(
        this.$store.state[this.request_prefix],
        { container_id: this.id },
        "container"
      )
      // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
      if (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId) {
        //更新appid
        const appId = rectAttr.options.appId ? rectAttr.options.appId : rectAttr.options.myFetchParam?.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
        this.$styleToSaveModule("31CB73E03E24BBFF", "临时", appId, param.isClone, isSearchComponent, isNavComponent)
          .then(res => {
            if (!!res.appId) {
              // 没有myfetchparam的组件 比如搜索组件 更新appId
              rectAttr.options.appId = res.appId
              // if (rectAttr?.options?.myFetchParam) {
              //   //如果拖入画布的组件有，myfetchparam，证明是自由布局或者轮播
              //   //则pageId,wfwfid,websiteId,更新为当前页面的值，防止老组件id不兼容
              //   const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
              //   rectAttr.options.appId = res.appId
              //   rectAttr.options.moduleId = res.moduleId
              //   rectAttr.options.myFetchParam.pageId = pageId
              //   rectAttr.options.myFetchParam.wfwfid = wfwfid
              //   rectAttr.options.myFetchParam.websiteId = websiteId
              //   rectAttr.options.myFetchParam.appId = res.appId
              // }
              // 克隆的组件需要将原组件的子页面相关id清空
              if (param.isClone) {
                delete rectAttr.options.detailPageId
                delete rectAttr.options.detailPageTemplateEncId
                delete rectAttr.options.listPageId
                delete rectAttr.options.listPageTemplateEncId
              }
              const params = {
                containerID: this.id,
                data: rectAttr
              }
              // 先删除后面再添加，避免add过程失败，复制的组件id未变
              let newIndex = param.index
              param.cellRect.splice(newIndex, 1)
              this.$store.dispatch(this.request_prefix + "/addElement", params)

              const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
                container_id: this.id
              }).children
              // let _rect_id = allRects.length ? allRects[allRects.length - 1].rect_id : -1
              let _rect_id = -1
              if (allRects.length > 0) {
                _rect_id = smartMathMax(
                  ...allRects.map(function(o) {
                    return o.rect_id
                  })
                )
              }
              let rect_id = _rect_id
              this.activateEv(this.id, rect_id, rectAttr.shape)
              if (typeof newIndex !== "undefined") {
                param.cellRect.splice(newIndex, 0, rect_id)
              } else {
                param.cellRect.push(rect_id)
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        const params = {
          containerID: this.id,
          data: rectAttr
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
        // this.activateEv(this.id, rect_id, rectAttr.shape)
        let newIndex = param.index
        const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          container_id: this.id
        }).children
        // let _rect_id = allRects.length ? allRects[allRects.length - 1].rect_id : -1
        let _rect_id = -1
        if (allRects.length > 0) {
          _rect_id = smartMathMax(
            ...allRects.map(function(o) {
              return o.rect_id
            })
          )
        }
        let rect_id = _rect_id
        if (typeof newIndex !== "undefined") {
          param.cellRect.splice(newIndex, 1, rect_id)
        } else {
          param.cellRect.push(rect_id)
        }
        // this.activateEv(this.id, rect_id, rectAttr.shape)
      }
      // const lowerShape = rectAttr.shape.toLowerCase()
      //如果是自由布局组件 那就要检测自由布局组件内的组件是否有appid
      // if (lowerShape.includes("layout")) {
      //   const allElementInLayout = getAllElementsInColsInLayoutComponent(rectAttr.options.rows)
      //   for (let uid in allElementInLayout) {
      //     const col = allElementInLayout[uid]
      //     col.elementInLayout &&
      //     Array.isArray(col.elementInLayout) &&
      //     col.elementInLayout.forEach(elementInLayout => {
      //       if (elementInLayout.appId) {
      //         const { elementInLayoutId } = elementInLayout
      //         this.$saveModule(
      //           { container_id: this.ids.container_id, rect_id: rectAttr.rect_id, uid, elementInLayoutId },
      //           "31CB73E03E24BBFF",
      //           "临时",
      //           false,
      //           elementInLayout.appId
      //         )
      //       }
      //     })
      //   }
      // }
    },
    // 横向标签布局 处理tab对应通栏索引值 为了显示隐藏
    newLayout() {
      let rows = this.layout.layout.rows
      let index = 0
      rows[0].options.index = 0 //第一行为横向标签索引为0
      for (let i = 1; i < rows.length; i++) {
        if (rows[i].options.tabRowStart) {
          index++
        }
        if (rows[i].options.tabColStart) {
          index++
        }
        rows[i].options.index = index
      }
      return this.layout
    },
    dragoverEv(e) {
      this.$emit("dragoverEv", e)
    },
    changeOrder() {
      console.log("change 顺序")
    },
    paddingMouseenter(e) {
      if (
        !this.paddingDragging &&
        !this.$store.state.states.isClonePattern &&
        !this.$store.state.states.isOrderPattern
      ) {
        e.currentTarget.classList.add("active")
      }
    },
    paddingMouseleave(e) {
      if (!this.paddingDragging) {
        e.currentTarget.classList.remove("active")
      }
    },
    paddingResizeStart(e) {
      this.paddingDragging = true
      this.resizeStartSite = {
        top: e.clientY
      }
    },
    paddingResizingEv: _throttle(function (paddingIndex, e) {
      let diff = (e.clientY - this.resizeStartSite.top) / this.zoom
      let newVal = this.layout.options.padding[paddingIndex] + diff
      newVal = newVal < 0 ? 0 : newVal
      this.resizeStartSite.top = e.clientY
      this.$changeOptionsEV(parseInt(newVal), "padding." + paddingIndex, false, "", {
        container_id: this.id,
        pageLayoutId: this.layoutIndex
      }, true)
    }, 5),
    paddingResizeStop(paddingIndex, e, el) {
      let diff = (e.clientY - this.resizeStartSite.top) / this.zoom
      let newVal = this.layout.options.padding[paddingIndex] + diff
      this.resizeStartSite.top = e.clientY
      this.$changeOptionsEV(parseInt(newVal), "padding." + paddingIndex, false, "", {
        container_id: this.id,
        pageLayoutId: this.layoutIndex
      }, true)
      this.resizeStartSite = null
      this.paddingDragging = false
      // el.classList.remove("active")
    },
    // 从菜单栏拖动组件到页面布局
    handleAutoLayoutDragover(e, insertIndex) {
      return
    },
    getInsertIndex(e) {
      let _this = this
      let top = Number(e.offsetY) / this.zoom //鼠标在当前元素上的位置
      let left = Number(e.offsetX) / this.zoom
      let _index = 0
      let targetPosition = e.target.getBoundingClientRect()
      let parentNode = this.getParentNode(e.target)
      if (parentNode.length === 0) {
        _index = _this.options.elementOptions.length
        return _index
      }
      let parentPosition = parentNode[0].getBoundingClientRect()
      //垂直方向排列
      const diffTop = targetPosition.top - parentPosition.top
      let top1 = 0
      _index = _this.pageLayoutList.findIndex((item, index) => {
        top1 += document.getElementsByClassName("page-layout-wrapper")[index].getBoundingClientRect().height
        return top1 > diffTop
      })
      _index = top / targetPosition.height < 0.5 ? _index : _index + 1 //超过元素高度一半显示在下方，否则显示在上方
      return _index
    },
    judgeIsShow(data) {
      let tf = false
      data.forEach((item, index) => {
        if (item.isShow) {
          tf = true
        }
      })
      return tf
    },
    getBoxShadowStyle(options) {
      let tmpStyle = ""
      if (!options.boxShadowH || options.boxShadowH.length === 0) {
        return tmpStyle
      }
      if (Array.isArray(options.boxShadowH)) {
        options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${options.boxShadowH[index]}px ${options.boxShadowV[index]}px ${options.boxShadowBlur[index]}px ${options.boxShadowSpread[index]}px ${this.$parseColor(options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${options.boxShadowH}px ${options.boxShadowV}px ${options.boxShadowBlur}px ${options.boxShadowSpread}px ${this.$parseColor(options.boxShadowColor)}`
      }
      return tmpStyle
    },
    setPageLayout(e) {
      this.$emit("setPageLayout")
    }
  },
  mounted() {
    if(!this.options.hasOwnProperty('layout') || !this.options.layout){
      // 初始化新的布局组件
      this.primaryLayout()
    }
    this.$initPlugin(this.options.pluginName, [], "options.pluginName")
    if (this.isAccordionLayout) {
      this.openIndex = this.defaultOpenIndex
    }
  }
}
</script>

<style scoped>
.layout-row {
  width: 100%;
}

.layout-row__container {
  display: flex;
  text-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  overflow: visible;
  width: 100%;
  height:100%;
}

.icon.add-col {
  position: absolute;
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  top: 50%;
  right: -9px;
  margin-top: -9px;
  z-index: 9999;
  cursor: pointer;
}

.layout-col-container {
  position: relative;
  display: flex;
  text-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  overflow: visible;
  width: 100%;
  height: 100%;
}

.layout-col {
  position: relative;
  box-sizing: content-box;
  width: 100%;
  z-index: 2;
  max-width: 100%;
  height: 100%;
}
.layout-col[data-level="top-level"] {
  z-index: 10000 !important;
}
.layout-row {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: left;
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  max-width: 100%;
  width: 100%;
  overflow: visible;
}

.drag-handle-left {
  position: absolute;
  z-index: 10;
  width: 20px;
  height: 100%;
  left: -10px;
  background-color: green;
  cursor: ew-resize;
}

.drag-handle-right {
  position: absolute;
  z-index: 10;
  width: 20px;
  height: 100%;
  right: -10px;
  background-color: green;
  cursor: ew-resize;
}


.row-sets {
  position: absolute;
  top: -9px;
  right: -9px;
  z-index: 9999;
}

.row-sets-toolbar {
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  border-radius: 999px;
  background-color: #3d3d3d;
  padding: 0 8px;
  height: 32px;
}

.row-sets-toolbar .icon {
  display: inline-block;
  font-size: 14px;
  width: 32px;
  text-align: center;
  height: 32px;
  line-height: 32px;
  color: #fff;
  cursor: pointer;
}

.row-sets-toolbar .icon:not(:last-child) {
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}

.row-sets-toolbar:before {
  display: block;
  content: "";
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.8) transparent transparent;
}

.default-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transition: all 0.1s;
}

.default-icon:hover {
  transform: scale(1.3);
}

.mover {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transform: scale(1.3);
}
.isDrag-over:before {
  position: absolute;
  height: 3px;
  width: 100%;
  background-color: var(--themeColor);
  top: -2px;
  content: "";
}
::v-deep.layout-col-fullPage .layout-col:last-child .layout-sets .cell-sets-toolbar,
::v-deep.layout-col-fullPage > .layout-container:last-child > .layout-sets .cell-sets-toolbar {
  right: -10px;
  left: auto;
  transform: translateX(0);
}
::v-deep.layout-col-fullPage .layout-col:last-child .layout-sets .cell-sets-toolbar:before,
::v-deep.layout-col-fullPage > .layout-container:last-child > .layout-sets .cell-sets-toolbar:before {
  left: auto;
  right: 14px;
  transform: translateX(0);
}
/*处理 字段长度不确定的情况  如接口返回的作者：**   时间：**  等*/
/*处理方式为 vdr尺寸自适应  容器高度自适应*/
/*目前为内部人员使用，所以交互上比较粗糙*/
::v-deep .layout-col.no-size-limit,
::v-deep .layout-col.no-size-limit .layout-container,
::v-deep .layout-col.no-size-limit .layout-columns,
::v-deep .layout-col.no-size-limit .layout-cell-container {
  height: unset !important;
  max-height: unset !important;
}
::v-deep .layout-col.no-size-limit.vertical .layout-cell-container > .vdr {
  display: block;
  margin-top: var(--custom-margin);
}
::v-deep .layout-col.no-size-limit.vertical .layout-cell-container > .vdr:first-child {
  margin-top: 0;
}
::v-deep .layout-col.no-size-limit.horizon .layout-cell-container > .vdr {
  display: inline-block;
  margin-left: var(--custom-margin);
}
::v-deep .layout-col.no-size-limit.horizon .layout-cell-container > .vdr:first-child {
  margin-left: 0;
}
::v-deep .layout-col.no-size-limit .layout-cell-container > .vdr {
  position: relative;
  /* width: unset !important;
  height: unset !important; */
  transform: none !important;
}
/*::v-deep .el-drawer .el-drawer__body {*/
/*  height: inherit;*/
/*}*/
/*::v-deep .el-drawer .layout-col,*/
/*::v-deep .el-drawer .layout-col .layout-columns {*/
/*  height: 100% !important;*/
/*}*/
/*::v-deep .el-drawer {*/
/*  background-color: transparent;*/
/*  box-shadow: none;*/
/*}*/
.positionAbsolute {
  position: absolute;
}
.positionAbsolute.heightFix {
  position: fixed !important;
}

/* 行列通栏布局 */
/* ::v-deep .layout-col.row-col-layout.vertical-layout .layout-cell-container > .vdr {
  margin-top: var(--custom-margin-bottom) !important;
  margin-right: var(--custom-margin-right) !important;
} */
/* ::v-deep .layout-col.row-col-layout.horizon-layout .layout-cell-container > .vdr {
  display: inline-block;
  margin-left: var(--custom-margin-bottom) !important;
  margin-bottom: var(--custom-margin-right) !important;
} */
/* ::v-deep .layout-col.row-col-layout.vertical-layout .layout-cell-container > .vdr:first-child {
  margin-top: 0 !important;
}
::v-deep .layout-col.row-col-layout.horizon-layout .layout-cell-container > .vdr:first-child {
  margin-left: 0 !important;
} */
::v-deep .layout-col.row-col-layout .layout-cell-container > .vdr,
::v-deep .layout-row.row-col-layout .layout-cell-container > .vdr,
::v-deep .layout-col.row-col-layout .layout-cell-container > .accordionContent > .vdr,
::v-deep .layout-row.row-col-layout .layout-cell-container > .accordionContent > .vdr  {
  flex-shrink: 0; /* flex布局不改变子元素宽高 */
  position: relative;
  transform: none !important;
}
/* 开启自动布局下拖拽辅助线 */
::v-deep .row-col-layout .layout-cell-container > .dragging,
::v-deep .row-col-layout .hover-active .layout-cell-container,
::v-deep .row-col-layout .hover-active .layout-cell-container > .vdr .vdr_shade,
::v-deep .row-col-layout .hover-active .layout-cell-container > .accordionContent > .vdr .vdr_shade {
  cursor: grab !important;
}
::v-deep .row-col-layout .hover-active .layout-cell-container > .dragging > div {
  opacity: 0.5 !important;
}
::v-deep .vertical-layout .layout-cell-container > .ghost::after,
::v-deep .vertical-layout .layout-cell-container > .accordionContent > .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--themeColor);
}
/* 以下custom-margin取的cell.vue里面的值 */
::v-deep .vertical-layout .layout-cell-container > .ghost.before::after {
  top: var(--custom-margin); 
}
::v-deep .vertical-layout .layout-cell-container > .ghost.after::after {
  bottom: var(--custom-margin);
}
::v-deep .horizon-layout .layout-cell-container > .ghost::after{
  content: "";
  position: absolute;
  top: 0;
  width: 3px;
  height: 100%;
  background: var(--themeColor);
}
::v-deep .horizon-layout .layout-cell-container > .ghost.before::after{
  top: 0;
  left: var(--custom-margin);
}
::v-deep .horizon-layout .layout-cell-container > .ghost.after::after{
  left: auto;
  right: var(--custom-margin);
}
::v-deep .row-col-layout .layout-cell-container > .vdr:first-child::after {/* 第一个元素前不要偏移值 */
  top: 0 !important;
  left: 0 !important;
}
::v-deep .row-col-layout .layout-cell-container > div:last-of-type::after {/* 最后一个元素后不要偏移值 */
  bottom: 0 !important;
  right: 0 !important;
}
::v-deep .row-col-layout .layout-cell-container .ref-line {/* 隐藏对齐辅助线 */
  display: none !important;
}
</style>
